import { useDashboards } from '../useDashboards';

export function useDefaultDashboard(options: Parameters<typeof useDashboards>[1] = {}) {
  const { dashboards, ...rest } = useDashboards({}, { ...options });

  const defaultDashboard = dashboards?.[0];

  return { defaultDashboard, ...rest };
}
